import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { AnalyticsAPICampaignType, CampaignsPerformanceResponse } from './types';
import { getBaseUrl, getDateRangeForApiCall } from '../utils';

export const getCampaignsPerformance = async (
  entityType: Extract<EntityType, 'venue' | 'merchant'>,
  entityId: string,
  interval: Interval,
) => {
  const { data } = await merchantGatewayApi.get<CampaignsPerformanceResponse>(
    `${getBaseUrl(entityType, entityId)}/campaigns-performance/`,
    {
      params: {
        ...getDateRangeForApiCall(interval),
      },
    },
  );
  return data;
};

export const getSingleCampaignPerformance = async (
  entityType: Extract<EntityType, 'venue' | 'merchant'>,
  entityId: string,
  interval: Interval,
  campaignId: string,
  campaignType: AnalyticsAPICampaignType,
) => {
  const { data } = await merchantGatewayApi.get<CampaignsPerformanceResponse>(
    `${getBaseUrl(entityType, entityId)}/campaigns-performance/${campaignId}`,
    {
      params: {
        ...getDateRangeForApiCall(interval),
        campaign_type: campaignType,
      },
    },
  );
  return data;
};
